/* Stylesheet */

.info_icon_wrapper {
  position: relative;

  .content_container {
    padding: 16px 21px 16px 21px;
    display: block;
    position: absolute;
    top: 0;
    right: 42px;
    max-height: 242px;
    width: 352px;
    color: var(--ion-color-text-secondary);
    background: var(--ion-gradient-dark-transparent);
    border-radius: 8px;
    overflow: auto;
    z-index: 1000;
    box-shadow: var(--ion-box-shadow);

    p {
      font-size: 0.875rem;
    }
  }

  .backdrop {
    position: fixed;
    opacity: 0;
    height: 100%;
    top: 0;
    cursor: default;
  }
}
